import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../../components/fields';
import messages from '../../../../../text/messages';
import { formSettings } from './settings';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { updateI9 } from '../../../../../reducers/i9s';
import { updateUserDetails, updateUserProfile } from '../../../../../reducers/identity';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Document from './../../../../../components/document';
import { DOC_LIST_TYPES } from '../utilities';
import { sign, getSignatures } from '../../../../../reducers/signatures';
import { setProgressionProperties } from '../../../../../reducers/onboarding';
import RejectDocumentDialog from './dialogs/rejectDocument';

class DocumentStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: { open: false }
        };

        this.submit = this.submit.bind(this);
        this.getSignatureId = this.getSignatureId.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        const { role, getSignatures, setProgressionProperties } = this.props;
        getSignatures(role, signatures => {
            const signatureId = this.getSignatureId();
            const properties = {};
            properties[signatureId] = signatures.find(s => s.name === signatureId);
            setProgressionProperties({ ...properties });
        });
    }

    submit(action) {
        const { role, sign, signature } = this.props;
        if (signature) {
            action({ branch: 'default' });
            return;
        }

        sign(role, this.getSignatureId(), { branch: 'default' });
    }

    onOpen() {
        this.setState({ modal: { open: true } });
    }

    onClose() {
        this.setState({ modal: { open: false } });
    }

    getSignatureId() {
        const { document } = this.props;
        const { type, properties } = document;
        const { issuingAuthority, docNumber, expDate } = properties;
        return `Witness_verified:${type}:${issuingAuthority}:${docNumber}:${expDate}`;
    }

    render() {
        const { modal } = this.state;
        const { handleSubmit, onSubmit, submitting, back, document, signatures } = this.props;
        if (!signatures) return null;

        const { i9 } = this.props;
        const { worker_first_name, worker_last_name } = i9;
        const { type } = document;
        const worker_name = worker_first_name + ' ' + worker_last_name;
        let listType = 'A';
        for (const key in DOC_LIST_TYPES) {
            if (DOC_LIST_TYPES[key].find(t => t === type) !== undefined) {
                listType = key;
                break;
            }
        }

        return (
            <div>
                <form onSubmit={handleSubmit(() => this.submit(onSubmit))}>
                    <div className="row section">
                        <div className="col-xs-12 section">
                            <Document
                                id={`i9-${listType}-${type}`}
                                docType={`i9-${listType}-${type}`}
                                view={{ showHeader: false, component: 'icon-download' }}
                                ownerRole={{ type: 'contractor', id: i9.worker_contractor_id }}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-8">
                            <FormattedHTMLMessage
                                id={'witness.driversLicense.intro1'}
                                defaultMessage={`Please inspect {name}'s document and verify that<br />1) it appears to you to be genuine, and<br />2) its details match the following:`}
                                values={{ name: worker_name }}
                                tagName={'p'}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-4">
                            <Field name="type" disabled={true} component={TextField} placeholder={messages.documentType} />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <Field name="properties.issuingAuthority" disabled={true} component={TextField} placeholder={messages.issuingAuthority} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-4">
                            <Field name="properties.docNumber" disabled={true} component={TextField} placeholder={messages.documentId} />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <Field name="properties.expDate" disabled={true} component={TextField} placeholder={messages.expirationDate} />
                        </div>
                    </div>

                    <WizardButtons
                        disabled={submitting}
                        back={{ action: back }}
                        save={{ action: this.onOpen, message: <FormattedMessage id={'verify.thatsNotId'} defaultMessage={"That's not it"} /> }}
                        submit={{ message: <FormattedMessage id={'verify'} defaultMessage={'VERIFY'} /> }}
                    />
                </form>
                <RejectDocumentDialog modal={modal} onClose={this.onClose} onSubmit={onSubmit} />
            </div>
        );
    }
}

DocumentStep = reduxForm(formSettings)(DocumentStep);
const mapStateToProps = (state, props) => {
    const { document } = props;
    const { type, properties } = document;
    const { issuingAuthority, docNumber, expDate } = properties;
    const signatureId = `Witness_verified:${type}:${issuingAuthority}:${docNumber}:${expDate}`;
    const signatures = state.signatures.list;
    const signature = signatures ? signatures.find(s => s.name === signatureId) : undefined;

    return {
        role: state.identity.role,
        i9: state.identity.details,
        initialValues: { ...props.document },
        signatures,
        signature
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateI9,
            updateUserDetails,
            updateUserProfile,
            sign,
            getSignatures,
            setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/documentStep.jsx